<div>
  <!-- File Selection -->
  <input type="file" multiple (change)="onFileSelected($event)" hidden #fileInput/>
  <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">
    <mat-icon>upload</mat-icon>
    Odaberite datoteke
  </button>

  @if (existingFiles.length > 0) {
    <div>
      <mat-list>
        @for (file of existingFiles; track trackByFileInfo($index, file)) {
          <mat-list-item>
            <mat-icon mat-list-icon>insert_drive_file</mat-icon>
            <span>{{ file.name }}</span>
            <button
              type="button"
              mat-icon-button
              color="primary"
              (click)="downloadFile(file)"
              matTooltip="Preuzmi datoteku"
              >
              <mat-icon>download</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              color="warn"
              (click)="deleteFile(file)"
              matTooltip="Obriši datoteku"
              >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
</div>